<div class="flex h-screen justify-center items-center">
  <div class="text-center">Loading....</div>
</div>
